import dayjs from 'dayjs'

export const createDateString = (props: { date: string; language: string }) => {
  const dateDayJs = dayjs(props.date).locale(props.language)
  return `${dateDayJs.format('MM/DD')} (${dateDayJs.format('dd')})`
}

/**
 * 日付（`YYYY-MM-DD` / `YYYY/MM/DD`）と時刻（`HH:mm` / `HH:mm:ss`）から、タイムゾーンを持たない
 * `YYYY-MM-DD HH:mm:ss` を組み立てる。
 * Date や dayjs に変換するとブラウザのタイムゾーンで解釈され、DST で存在しない時刻
 * （例: America/New_York の 2026-03-08 02:00）が別の時刻に変わるため、文字列のまま扱う
 */
export const toNaiveDateTimeString = (date: string, time: string): string => {
  const dateMatch = /^(\d{4})[-/](\d{2})[-/](\d{2})$/.exec(date)
  const timeMatch = /^(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(time)
  if (!dateMatch || !timeMatch) {
    throw new Error(`Invalid date time: ${date} ${time}`)
  }
  const [, year, month, day] = dateMatch
  const [, hour, minute, second = '00'] = timeMatch

  // 実在する日時かを UTC で確かめる。UTC には DST がないので、存在する日時は丸められない
  const utc = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)))
  const normalized = utc.toISOString().slice(0, 19).replace('T', ' ')
  const result = `${year}-${month}-${day} ${hour}:${minute}:${second}`
  if (normalized !== result) {
    throw new Error(`Invalid date time: ${date} ${time}`)
  }

  return result
}
